export default __webpack_public_path__ + "static/media/Caisse.2a8b7936.png";